/* Project Import will be here */
import { getErrorObject, errorToast } from "utilities/utils";
import Constants from "utilities/appConstants";
import { showMsgFromJson } from "reducers/common";
import { GetCheckoutSummaryApi } from "services/checkout";
/* Project Import will be here */

export const types = {
    CHECK_OUT_REQUEST: "checkout/CHECK_OUT_REQUEST",
    CHECK_OUT_SUCCESS: "checkout/CHECK_OUT_SUCCESS",
    CHECK_OUT_FAILURE: "checkout/CHECK_OUT_FAILURE",
    UPDATE_EXPRESS_DELIVERY_DATE: "checkout/UPDATE_EXPRESS_DELIVERY_DATE",
    UPDATE_SELECTED_ADDR_ID: "checkout/UPDATE_SELECTED_ADDR_ID",
};

const initialState = {
    standardDeliveryDate: null,
    expressDeliveryDate: null,
    selectedAddrId: 0,
    isLoading: false,
};

export const checkout = (state = initialState, action) => {
    switch (action.type) {
        case types.CHECK_OUT_REQUEST:
            return {
                ...state,
                isLoading: true
            };
        case types.CHECK_OUT_SUCCESS:
            return {
                ...state,
                ...action.payload,
                isLoading: false
            };
        case types.CHECK_OUT_FAILURE:
            return {
                ...initialState
            };
        case types.UPDATE_EXPRESS_DELIVERY_DATE:
            return {
                ...state,
                expressDeliveryDate: action.payload.expressDeliveryDate
            };
        case types.UPDATE_SELECTED_ADDR_ID:
            return {
                ...state,
                selectedAddrId: action.payload.addrId
            };
        default:
            return state;
    }
};

/* Get all necessary data for checkout page */
export const getCheckoutData = () => {
    return async (dispatch, getState) => {
        dispatch({ type: types.CHECK_OUT_REQUEST });
        try {
            const response = await GetCheckoutSummaryApi();
            dispatch({
                type: types.CHECK_OUT_SUCCESS,
                payload: {
                    isLoading: false,
                    standardDeliveryDate: response.data.Data.DeliveryDate
                }
            });
        }
        catch (error) {
            dispatch(promiseCatchBlock(error, types.CHECK_OUT_FAILURE, true));
        }
    }
};

/* Update the product express delivery date */
export const updateExpressDeliveryDate = dateString => {
    return async (dispatch) => {
        dispatch({
            type: types.UPDATE_EXPRESS_DELIVERY_DATE,
            payload: { expressDeliveryDate: dateString }
        });
    };
};


/* Update the product express delivery date */
export const updateSelectedAddrId = (addrId) => {
    return async (dispatch) => {
        dispatch({
            type: types.UPDATE_SELECTED_ADDR_ID,
            payload: { addrId: addrId }
        });
    };
};

/* Generic code for promise catch block */
const promiseCatchBlock = (error: any, type: string, showToast: boolean = false) => {
    return (dispatch) => {
        const { message, errorCode } = getErrorObject(error);

        /* Update the error response in the store */
        if (type !== "") {
            dispatch({
                type: type,
                payload: { error: message }
            });
        }

        /* Show error message */
        if (showToast) {
            /* If error code is exist show the error code message or show the error message returned by the API request */
            if (errorCode !== "")
                dispatch(showMsgFromJson(`common.alerts.error.${errorCode}`, Constants.ERROR));
            else
                errorToast({ content: message });
        }
    }
};